import { render, staticRenderFns } from "./MetadadosExtensao.vue?vue&type=template&id=094cefdc&lang=html"
import script from "./MetadadosExtensao.vue?vue&type=script&lang=js"
export * from "./MetadadosExtensao.vue?vue&type=script&lang=js"
import style0 from "./MetadadosExtensao.vue?vue&type=style&index=0&id=094cefdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports